import {ParamsProps} from '@/components/WdiBus/FormPage';
import {Enum} from '@/enums/system';
import {ResponseStatus} from '@/utils/request';
import {wdiCore, WdiModalAppResult} from '@/components/WdiControls';
import {DataOptions} from '@/services/basic/metadata';
import {FormApi} from '@/services/sales';
import DataStore from '@/components/GridWidget/DataStore';
import {FormSpMkt, FormSpMktDetail} from "@/services/mkt/sp";
import {Supplier} from "@/services/mdm/supplier";
import {Company} from "@/services/mdm/company";
import {Staff} from "@/services/basic/staff";

export type ViewEntityProps = {
  form?: API.Form,
  formSpMkt?: API.FormSpMkt,
  preForm?: API.Form,
  paymentMethod?: API.DataOptions,
  supplier?: API.Supplier;
  company?: API.Company;

  formSpMktDetails?: API.FormSpMktDetail[],
  invoices?: API.Invoice[],
  //sapAdvances?: any[],
  relationType?: number,
  relatedFormId?: number,
  formId?: number;
  statusId?: number;
  formTypeId?: number;
  pageTypeId?: number;
  paymentMethodId?: number,
  supplierId?: number,
  formSaMktId?: number,
  reimburseType?: number,
  userId?: number;
  positionId?: number;
  deptId?: number;
  companyCode?: string;
  payToUserId?: number;
  vatTypeId?: number;
  payToTypeId?: number;
  payToUser?: API.Staff;
  payTypeId?: number;
}

export const initApplyPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN,
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId || params.relatedFormId) {
    // 退回待修改
    const formResponse = await FormApi.get(params.formId || params.relatedFormId || 0);
    viewEntity.form = formResponse.data;
    if (!viewEntity.form) {
      result.message = '无效的退回待修改单';
      return result;
    }
    if (params.formId) {
      viewEntity.formId = params.formId;
    } else {
      viewEntity.relationType = Enum.FormRelationType.REJECTED;
      viewEntity.relatedFormId = params.relatedFormId;
    }
    const formSpMktResponse = await FormSpMkt.get(viewEntity.form.formId);
    viewEntity.formSpMkt = formSpMktResponse.data;
    viewEntity.formSaMktId = viewEntity.formSpMkt.formSaMktId;
    viewEntity.reimburseType = viewEntity.formSpMkt.reimburseType;
    viewEntity.paymentMethodId = viewEntity.formSpMkt.paymentMethodId;
    viewEntity.userId = viewEntity.form.userId;
    viewEntity.positionId = viewEntity.form.positionId;
    viewEntity.deptId = viewEntity.form.deptId;
    viewEntity.pageTypeId = viewEntity.form.pageTypeId;
    viewEntity.formTypeId = viewEntity.form.formTypeId;
    viewEntity.companyCode = viewEntity.formSpMkt.companyCode;
    viewEntity.payToTypeId = viewEntity.formSpMkt.payToTypeId;
    viewEntity.payToUserId = viewEntity.formSpMkt.payToUserId;
    viewEntity.payTypeId = viewEntity.formSpMkt.payTypeId;
  } else {
    // 直接申请
    viewEntity.paymentMethodId = params.paymentMethodId;
    viewEntity.supplierId = params.supplierId;
    viewEntity.pageTypeId = params.pageTypeId;
    viewEntity.formTypeId = params.formTypeId;
    viewEntity.formSaMktId = params.formSaMktId;
    viewEntity.reimburseType = params.reimburseType;
    viewEntity.userId = params.userId;
    viewEntity.positionId = params.positionId;
    viewEntity.deptId = params.deptId;
    viewEntity.companyCode = params.companyCode;
    viewEntity.payToTypeId = params.payToTypeId;
    viewEntity.payToUserId = params.payToUserId;
    viewEntity.payTypeId = params.payTypeId;

  }

  if (viewEntity.paymentMethodId) {
    const paymentMethodResponse = await DataOptions.search({
      typeGroup: 5,
      inValues: String(viewEntity.paymentMethodId),
    });
    viewEntity.paymentMethod = paymentMethodResponse?.data[0];
  }
  if (viewEntity.form?.formId) {
    const formSpMktDetailsResponse = await FormSpMktDetail.getsForApproval(viewEntity.form.formId);
    viewEntity.formSpMktDetails = DataStore.init(formSpMktDetailsResponse.data);
    viewEntity.supplierId = viewEntity.formSpMktDetails[0]?.supplierId;
  } else {
    const formSpMktDetailsResponse = await FormSpMktDetail.getsForApply({
      formSaMktId: viewEntity.formSaMktId,
      formSpMktId: viewEntity.formSpMkt?.formSpMktId,
      paymentMethodId: viewEntity.paymentMethodId,
      companyCode: viewEntity.companyCode,

    });
    viewEntity.formSpMktDetails = DataStore.init(formSpMktDetailsResponse.data);
  }
  if (viewEntity.supplierId) {
    await Supplier.get(viewEntity.supplierId).then(res => {
      viewEntity.supplier = res.data;
    })
    // await FormSpMkt.getSap(String(viewEntity.supplier?.supplierCode)).then(res => {
    //   viewEntity.sapAdvances = res.data;
    // })
  }
  if (viewEntity.companyCode) {
    await Company.get(viewEntity.companyCode).then(res => {
      viewEntity.company = res.data;
    })
  }
  if (viewEntity.payToUserId) {
    const userResp = await Staff.get(viewEntity.payToUserId);
    if (userResp.data) {
      viewEntity.payToUser = userResp.data;
    }
  }
  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
};

export const initApprovalPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN,
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId) {
    // 从草稿打开
    const formSPMktResponse = await FormSpMkt.get(params.formId);
    viewEntity.formSpMkt = formSPMktResponse.data;
    if (!viewEntity.formSpMkt) {
      result.message = '无效的草稿单';
      return result;
    }
    const formResponse = await FormApi.get(params.formId);
    viewEntity.form = formResponse.data;
    const formSpMktDetailsResponse = await FormSpMktDetail.getsForApproval(params.formId);
    viewEntity.formSpMktDetails = DataStore.init(formSpMktDetailsResponse.data);


  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
};

export const initRowFieldConfigs = (record: any) => {
  return ['rowNumber', 'productId', 'ecMktId', 'paymentMethodId', 'amountSa', 'amountNotPaid', 'amountInVat', 'amountExVat', 'remark'
    , 'tpmDetailId', 'amountPaid', 'tax', 'remarkSa'];
};

export const initApprovalRowFieldConfigs = (record: any) => {
  const columns = initRowFieldConfigs(record);
  columns.push(...['amountOriginal', 'tpmDetailId', 'formSpMktDetailId', 'exportStatusName', 'exportDate', 'exportUserName', 'amountExVat', 'tax', 'modifiedUserId', 'modifyReason',
    'voucherNo']);
  columns.push(...getAllHasValueColumns(record));
  return columns;
};

export const getAllHasValueColumns = (record: any) => {
  const hasValueColumns: string[] = [];
  for (const column of allExtensionsColumns) {
    if (!wdiCore.Object.IsNullOrUndefined(record[column])) {
      hasValueColumns.push(column);
    }
  }
  return hasValueColumns;
};
const allExtensionsColumns = [
  'bankAccountId', 'bankAccountName', 'companyCode', 'supplierId', 'payToUserId'
]
export const replaceColumns = {
  'productId': [
    {name: 'productCode', displayName: '产品别编号'},
    {name: 'productName', displayName: '产品别名称'},
  ],
  'ecMktId': [
    {name: 'ecMktName', displayName: '费用项'},
  ],
  'paymentMethodId': [
    {name: 'paymentMethodName', displayName: '支付方式'},
  ],
  'supplierId': [
    {name: 'supplierCode', displayName: '供应商编号'},
    {name: 'supplierName', displayName: '供应商名称'},
  ],
  'companyCode': [
    {name: 'companyCode', displayName: '公司编号'},
    {name: 'companyName', displayName: '公司名称'},
  ],
  'bankAccountId': [
    {name: 'bankAccountNo', displayName: '银行账号'},
    {name: 'bankAccountName', displayName: '银行账号名称'},
  ],
};
